// src/components/SPanel/Home/homeEditStore.js
//
// Modul „Editează” al paginii principale: îl pornește butonul din rândul de sus
// (pe telefon bara fixă a elevului, pe ecran lat rândul din pagină) și îl
// folosește grila de widget-uri. Tot în rândul de sus stau, la editare,
// „Adaugă” și „Resetează”: grila își înregistrează aici ce fac.

import { useSyncExternalStore } from "react";

let editing = false;
const listeners = new Set();
let actions = null;

export function isHomeEditing() {
   return editing;
}

export function setHomeEditing(value) {
   const next = Boolean(value);
   if (next === editing) return;
   editing = next;
   listeners.forEach((listener) => listener());
}

export function toggleHomeEditing() {
   setHomeEditing(!editing);
}

function subscribe(listener) {
   listeners.add(listener);
   return () => listeners.delete(listener);
}

export function useHomeEditing() {
   return useSyncExternalStore(subscribe, isHomeEditing, isHomeEditing);
}

/** Grila: { add, reset }; întoarce funcția care le scoate. */
export function setHomeEditActions(next) {
   actions = next;
   return () => {
      if (actions === next) actions = null;
   };
}

/** Rândul de sus: „add” | „reset”. */
export function runHomeEditAction(name) {
   actions?.[name]?.();
}
